export default function () {
  return {
    current: {
      dateField: 0,
      dateFormat: '',
      description: '',
      glob: '',
      id: '',
      multipleFiles: false,
      nameField: 0,
      pattern: '',
      setupMethod: '',
      static: false,
      system: '',
      timeField: 0,
      timeFormat: '',
      type: ''
    },
    update: {
      dateField: 0,
      dateFormat: '',
      description: '',
      glob: '',
      id: '',
      multipleFiles: false,
      nameField: 0,
      pattern: '',
      setupMethod: '',
      static: false,
      timeField: 0,
      timeFormat: '',
      type: ''
    },
    list: []
  }
}
